import React from "react";
import moment from "moment";
import { Row, Col, Typography } from "antd";
import Editor from "rich-markdown-editor";
import {
  StyledBox,
  StyledList,
  StyledDetail,
  StyledTitle,
  TitleContainer,
} from "components/job/index/jobInformationRow";
import LabelAndValue from "components/job/index/labelAndValue";
import LabelSkeleton from "../../../lib/loader/job/index/labelSkeleton";

const { Text } = Typography;

const JobInfo = (props) => {
  const { data, status } = props;
  const [orderRemarks, setOrderRemarks] = React.useState(null);

  // Component Use Effect
  React.useEffect(() => {
    if (data?.remarks) {
      setOrderRemarks(data?.remarks);
    }
  }, [data]);

  return (
    <StyledBox>
      <Row gutter={4}>
        <Col span={24}>
          <StyledList>
            <TitleContainer>
              <StyledTitle>Job Information</StyledTitle>
            </TitleContainer>
            <Row gutter={2} style={{ padding: "10px" }}>
              <Col span={6}>
                <LabelAndValue
                  label="Type"
                  value={data?.type.name || "-"}
                  status={status}
                />
              </Col>
              <Col span={6}>
                <LabelAndValue
                  label="Quantity"
                  value={data?.quantity || "-"}
                  status={status}
                />
              </Col>
              <Col span={6}>
                <LabelAndValue
                  label="Size"
                  value={data?.job_general?.size || "-"}
                  status={status}
                />
              </Col>
              <Col span={6}>
                <LabelAndValue
                  label="Delivery Date"
                  value={
                    data?.delivery_date !== null
                      ? moment(data?.delivery_date)
                          .utc()
                          .format("DD MMM YYYY") || "-"
                      : "-"
                  }
                  status={status}
                />
              </Col>
            </Row>
          </StyledList>
        </Col>

        <Col span={24}>
          <StyledList>
            <Row gutter={2} style={{ padding: "10px" }}>
              <Col span={6}>
                <LabelAndValue
                  label="Orientation"
                  value={data?.job_general?.orientation || "-"}
                  status={status}
                />
              </Col>

              <Col span={6}>
                <LabelAndValue
                  label="Pages"
                  value={data?.job_general?.pages || "-"}
                  status={status}
                />
              </Col>
            </Row>
          </StyledList>
        </Col>

        <Col span={24}>
          <StyledList>
            <Row gutter={2} style={{ padding: "10px" }}>
              <Col span={24}>
                <StyledDetail>
                  <Text className="title">
                    Finishings ({data?.finishings?.length})
                  </Text>
                  <Row>
                    {data?.finishings?.map((finishing, index) => (
                      <React.Fragment key={`finishing-${index}`}>
                        {status !== "success" || status === "loading" ? (
                          <LabelSkeleton />
                        ) : (
                          <Col span={6}>
                            <Text className="value">{finishing.name}</Text>
                          </Col>
                        )}
                      </React.Fragment>
                    ))}
                  </Row>
                </StyledDetail>
              </Col>
            </Row>
          </StyledList>
        </Col>

        <Col span={24}>
          <StyledList>
            <Row gutter={2} style={{ padding: "10px" }}>
              <Col span={24}>
                <StyledDetail>
                  <Text className="title">
                    Bindings ({data?.bindings?.length})
                  </Text>
                  <Row>
                    {data?.selected_binding?.map((binding, index) => (
                      <React.Fragment key={`binding-opt-${index}`}>
                        {status !== "success" || status === "loading" ? (
                          <LabelSkeleton />
                        ) : (
                          <Col
                            span={Boolean(binding.second_option) > 0 ? 12 : 8}
                          >
                            {binding.second_option ? (
                              <>
                                <Text className="value">{binding.name}</Text>
                                {binding.second_option.map((secondOption) => (
                                  <Text
                                    style={{
                                      fontSize: ".9rem",
                                      color: "#718096",
                                    }}
                                  >
                                    {` - ${secondOption.name || ""}: ${
                                      secondOption.value || ""
                                    }`}
                                  </Text>
                                ))}
                              </>
                            ) : (
                              <Text className="value">{binding.name}</Text>
                            )}
                          </Col>
                        )}
                      </React.Fragment>
                    ))}
                  </Row>
                </StyledDetail>
              </Col>
            </Row>
          </StyledList>
        </Col>
        <Col span={24}>
          <StyledList $last>
            <Row gutter={2} style={{ padding: "10px" }}>
              <Col span={24}>
                <>
                  <LabelAndValue label="Remarks" status={status} />
                  {data?.remarks ? (
                    <Editor readOnly={true} value={orderRemarks} />
                  ) : (
                    <p>-</p>
                  )}
                </>
              </Col>
            </Row>
          </StyledList>
        </Col>
      </Row>
    </StyledBox>
  );
};

export default JobInfo;
